import { useInstance } from 'intact-vue-next';
import { useKeyboard } from '../../hooks/useKeyboard';
var Direction;
(function (Direction) {
  Direction[Direction["Up"] = 0] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
  Direction[Direction["Left"] = 2] = "Left";
  Direction[Direction["Right"] = 3] = "Right";
})(Direction || (Direction = {}));
export function useKeyboards(panelRef, focusDate) {
  var instance = useInstance();
  var _useKeyboard = useKeyboard({
      down: function down(e) {
        focus(e, Direction.Down);
      },
      up: function up(e) {
        focus(e, Direction.Up);
      },
      right: function right(e) {
        focus(e, Direction.Right);
      },
      left: function left(e) {
        focus(e, Direction.Left);
      },
      enter: function enter() {
        select(focusDate.value);
      }
    }),
    add = _useKeyboard[0],
    remove = _useKeyboard[1];
  instance.on('show', add);
  instance.on('hide', remove);
  function select(date) {
    if (!date) return;
    var calendar = panelRef.value;
    if (!calendar) return; // maybe select time
    switch (calendar.type.value) {
      case 'date':
        calendar.days.onClick(date);
        break;
      case 'month':
        calendar.months.onClick(date);
        break;
      case 'year':
        calendar.years.onClick(date);
        break;
    }
  }
  function focus(e, direction) {
    var calendar = panelRef.value;
    if (!calendar) return;
    e.preventDefault();
    if (!focusDate.value) {
      focusDate.set(calendar.showDate.date.value);
      return;
    }
    var type = calendar.type.value;
    var upAndDownOffset = type === 'date' ? 7 : 4;
    var offset;
    switch (direction) {
      case Direction.Up:
        offset = -upAndDownOffset;
        break;
      case Direction.Down:
        offset = upAndDownOffset;
        break;
      case Direction.Left:
        offset = -1;
        break;
      case Direction.Right:
        offset = 1;
        break;
    }
    var _focusDate = focusDate.value;
    _focusDate = _focusDate.add(offset, type === 'date' ? 'day' : type);
    focusDate.set(_focusDate);
    // change panel show date
    calendar.showDate.date.set(_focusDate);
  }
}